import * as types from "./actionTypes";

export const markDocumentReadGrowUpFarms = (documentFilename) => ({
  type: types.MARK_DOCUMENT_READ_GROW_UP_FARMS,
  payload: documentFilename,
});
export const setGrowUpFarmsReadingLoading = (isLoading) => {
  return {
    type: types.SET_GROW_UP_FARMS_READING_LOADING,
    payload: isLoading,
  };
};
export const submitGrowUpFarmsQuestionnaire = (
  formName,
  formContent,
  typeCode
) => ({
  type: types.SUBMIT_GROW_UP_FARMS_QUESTIONNAIRE,
  payload: { formName, formContent, typeCode },
});
export const submitGrowUpFarmsFoodQuestionnaire = (
  formName,
  formContent,
  typeCode
) => ({
  type: types.SUBMIT_GROW_UP_FARMS_FOOD_QUESTIONNAIRE,
  payload: { formName, formContent, typeCode },
});
export const setGrowUpFarmsFoodQuestionnaireLoading = (isLoading) => {
  return {
    type: types.SET_GROW_UP_FARMS_FOOD_QUESTIONNAIRE_LOADING,
    payload: isLoading,
  };
};
export const setGrowUpFarmsFoodQuestionnaireResults = (results) => ({
  type: types.SET_GROW_UP_FARMS_FOOD_QUESTIONNAIRE_RESULTS,
  payload: results,
});
